export const HELP_MODEL_SLICE = 'helpModal';
export const HELPMODAL_INITIAL_STATE:HelpState = {
  helpModalState: false,
  sourceOfHelpClick: '',
};
